import type { EditAsideCurriculumSelector } from '@nodeTypeConfig/configTypes';

export const curriculumSelectorComponent: EditAsideCurriculumSelector = {
  component: 'curriculumSelector',
  reactComponent: 'AsideCurriculumSelector',
  property: 'themes',
  label: "Leerplanthema's",
  noChangeMessage: true,
};
